import { adminAdapter, AdminState } from './admin.entity';
import { Action, combineReducers } from '@ngrx/store';
import * as usersReducers from './users/user.reducer';
import { usersAdapter } from './users/user.entity';
import * as accountsReducers from './accounts/account.reducer';
import { accountsAdapter } from './accounts/account.entity';
import * as devicesReducers from './devices/device.reducer';
import { devicesAdapter } from './devices/device.entity';

export const initialState: AdminState = adminAdapter.getInitialState({
    ids: [],
    entities: null,
    users: usersReducers.initialState,
    accounts: accountsReducers.initialState,
    devices: devicesReducers.initialState
    //firmwares
});

export function adminReducer(state: AdminState, action: Action): AdminState {
    return combineReducers({
        users: usersReducers.reducer,
        accounts: accountsReducers.reducer,
        devices: devicesReducers.reducer
        //firmwares
    })(state, action) as AdminState;
}

export const usersSelectors = usersAdapter.getSelectors();
export const accountsSelectors = accountsAdapter.getSelectors();
export const devicesSelectors = devicesAdapter.getSelectors();
//firmwares
